import React from 'react'

function MoreInfo() {
  return (
    <div className=" more-info-container mt-5 mx-5">
      <div className="jumbo-2">Tech I have worked with: </div>
      <div className="technologies TechCard" align="center">
        <p>Programming Languages</p>
        <code>
          <img
            height="60"
            src="https://camo.githubusercontent.com/2771059ece39a91f0ca8afe0205a540e3af66f435508ba80b080eb249479d4dc/68747470733a2f2f696d672e69636f6e73382e636f6d2f636f6c6f722f34382f3030303030302f632d70726f6772616d6d696e672e706e67"
            alt="C"
            title="C"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/183423507-c056a6f9-1ba8-4312-a350-19bcbc5a8697.png"
            alt="Python"
            title="Python"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://github.com/PrinceCorwin/Useful-tech-icons/raw/main/images/Cplusplus.png?raw=true"
            alt="CPP"
            title="CPP"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/117447155-6a868a00-af3d-11eb-9cfe-245df15c9f3f.png"
            alt="JavaScript"
            title="JavaScript"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/183890598-19a0ac2d-e88a-4005-a8df-1ee36782fde1.png"
            alt="TypeScript"
            title="TypeScript"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/117201156-9a724800-adec-11eb-9a9d-3cd0f67da4bc.png"
            alt="Java"
            title="Java"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/185062810-7ee0c3d2-17f2-4a98-9d8a-a9576947692b.png"
            alt="Kotlin"
            title="Kotlin"
          />
        </code>
        <p>Web Development</p>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/117447535-f00a3a00-af3d-11eb-89bf-45aaf56dbaf1.png"
            alt="HTML"
            title="HTML"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/183898674-75a4a1b1-f960-4ea9-abcb-637170a00a75.png"
            alt="CSS"
            title="CSS"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/183577242-5081ea3b-7a3c-419b-9b81-014bf32e2e69.png"
            alt="Sass"
            title="Sass"
          />
        </code>

        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/183869554-ae3ce73a-b756-4cea-bb96-eadc96506102.png"
            alt="HTTP"
            title="HTTP"
          />
        </code>

        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/117208135-11134380-adf5-11eb-8878-040fd0f015b2.png"
            alt="REST"
            title="REST"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/182618508-1b12183b-5398-48d2-92e7-ff0969a22624.png"
            alt="Postman"
            title="Postman"
          />
        </code>

        <p>Libraries/Frameworks</p>

        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/183897015-94a058a6-b86e-4e42-a37f-bf92061753e5.png"
            alt="React"
            title="React"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://seeklogo.com/images/R/react-native-logo-221C671C70-seeklogo.com.png"
            alt="React Native"
            title="React Native"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Nextjs-logo.svg/1280px-Nextjs-logo.svg.png"
            alt="NextJS"
            title="NextJS"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/5307958/38454395-eba34a8a-3a90-11e8-9c95-680a7aea037f.png"
            alt="threejs"
            title="threejs"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/183898054-b3d693d4-dafb-4808-a509-bab54cf5de34.png"
            alt="Bootstrap"
            title="Bootstrap"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/183568594-85e280a7-0d7e-4d1a-9028-c8c2209e073c.png"
            alt="Node.js"
            title="Node.js"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/183859966-a3462d8d-1bc7-4880-b353-e2cbed900ed6.png"
            alt="Express"
            title="Express"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://github.com/PrinceCorwin/Useful-tech-icons/raw/main/images/material.png?raw=true"
            alt="MUI"
            title="MUI"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/183891303-41f257f8-6b3d-487c-aa56-c497b880d0fb.png"
            alt="SpringBoot"
            title="SpringBoot"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/117533873-484d4480-afef-11eb-9fad-67c8605e3592.png"
            alt="JUnit"
            title="JUnit"
          />
        </code>
        <p>Databases</p>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/183896128-ec99105a-ec1a-4d85-b08b-1aa1620b2046.png"
            alt="MySQL"
            title="MySQL"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/182884177-d48a8579-2cd0-447a-b9a6-ffc7cb02560e.png"
            alt="mongoDB"
            title="mongoDB"
          />
        </code>
        <p>Version Control</p>

        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/117364277-fc4eb280-aebd-11eb-8769-a3583c6a2037.png"
            alt="Git"
            title="Git"
          />
        </code>

        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/117364276-fc4eb280-aebd-11eb-92ba-8a6ef74b7313.png"
            alt="GitHub"
            title="GitHub"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/183889532-8bdf36de-c3fe-4800-ae29-c2d160ed5025.png"
            alt="GitLab"
            title="GitLab"
          />
        </code>
        <p>Miscellaneous</p>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/121302773-7aa5d680-c8fa-11eb-98aa-e016fdb2de32.png"
            alt="InteliJ"
            title="InteliJ"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/182618272-390ab138-7b29-44a0-85a2-62633957d815.png"
            alt="VisualStudio"
            title="VisualStudio"
          />
        </code>

        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/183912952-83784e94-629d-4c34-a961-ae2ae795b662.png"
            alt="Jira"
            title="Jira"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/184103699-d1b83c07-2d83-4d99-9a1e-83bd89e08117.png"
            alt="Selenium"
            title="Selenium"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/121401671-49102800-c959-11eb-9f6f-74d49a5e1774.png"
            alt="npm"
            title="npm"
          />
        </code>
        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/183049794-a3dfaddd-22ee-4ffe-b0b4-549ccd4879f9.png"
            alt="yarn"
            title="yarn"
          />
        </code>

        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/117207242-07d5a700-adf4-11eb-975e-be04e62b984b.png"
            alt="Maven"
            title="Maven"
          />
        </code>

        <code>
          <img
            height="60"
            src="https://user-images.githubusercontent.com/25181517/117269608-b7dcfb80-ae58-11eb-8e66-6cc8753553f0.png"
            alt="Android"
            title="Android"
          />
        </code>
      </div>
    </div>
  )
}

export default MoreInfo
